import React, { useState, useEffect, useCallback } from "react";
import "../Main.css";
import "./Navbar.css";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "./logoz-removebg-preview.png";
import { Link } from "react-router-dom";
import { feadata } from "../Feautured/FeaData";
import { FaBars } from "react-icons/fa6";

const Navbar = () => {
  const [show, setShow] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    about: false,
    services: false,
    careers: false,
    more: false,
  });

  // Function to close Offcanvas menu & reset dropdowns
  const handleClose = () => {
    setShow(false);
    setDropdownOpen({
      about: false,
      services: false,
      careers: false,
      more: false,
    });
  };

  // Function to show Offcanvas menu without opening dropdowns
  const handleShow = () => {
    setShow(true);
    setDropdownOpen({
      about: false,
      services: false,
      careers: false,
      more: false, // Ensures all dropdowns start closed
    });
  };

  // Function to toggle a specific dropdown (only one at a time)
  const toggleDropdown = (section) => {
    setDropdownOpen((prevState) => ({
      about: false,
      services: false,
      careers: false,
      more: false,
      [section]: !prevState[section], // Only one dropdown opens at a time
    }));
  };

  const handleScroll = useCallback(() => {
    requestAnimationFrame(() => {
      setIsScrolled(window.scrollY > 50);
    });
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
   <header id="header" className={`header sticky-top ${isScrolled ? 'scrolled' : ''}`}>
      <div
        className={`topbar d-flex align-items-center ${
          isScrolled ? "topbar-hidden" : ""
        }`}
      >
        <div className="container d-flex justify-content-center justify-content-md-between">
          <div className="d-none d-md-flex align-items-center mon ">
            <i className="bi bi-envelope me-1"></i>
            <a className="Atag" href="mailto:07802416170">
              info@jrcareltd.com
            </a>
          </div>

          <div className="d-flex align-items-center gap-3">
            <a id="xx" className="Atag" href="tel:07802416170">
              Call us now <i className="bi bi-phone me-1"></i> +44 07802416170
            </a>

            <a id="xx" className="Atag vk" href="tel:07802416170">
              <i className="bi bi-phone me-1"></i>
              +44 01316771557
            </a>
          </div>
        </div>
      </div>

      <div className="branding d-flex align-items-center">
        <div className="container position-relative d-flex align-items-center justify-content-end">
          <a href="/" className="logo d-flex align-items-center me-auto">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </a>

          <nav id="navmenu" className="navmenu">
            <ul>
              <li>
                <a href="/" className="active">
                  Home
                </a>
              </li>
              <li className="dropdown">
                <a href="">
                  <Link>
                    <span className="">ABOUT Us</span>
                  </Link>
                  <i className="bi bi-chevron-down toggle-dropdown"></i>
                </a>
                <ul>
                  <li>
                    <Link to="/Aboutz">
                      <a href="">About Us</a>
                    </Link>
                  </li>
                  <li>
                    <Link to="Socialvalue">
                      <a href="">Social Values</a>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="dropdown">
                <a href="">
                  <Link to="">
                    <span>SERVICES</span>
                  </Link>
                  <i className="bi bi-chevron-down toggle-dropdown"></i>
                </a>

                <ul>
                  {/* <li>
                    <a href="">
                      My Life Edinburgh : <br /> Private Care
                    </a>
                  </li> */}

                  {feadata.map((service) => (
                    <React.Fragment key={service._id}>
                      <li>
                        <Link to={`/service/${service._id}`}>
                          {service.title}
                        </Link>
                      </li>

                      {/* Optional 'More' dropdown */}
                      <li className="dropdown">
                        <ul>
                          <li>
                            <Link to={`/service/${service._id}`}>
                              Physical Disability Service
                            </Link>
                          </li>
                          <li>
                            <Link to={`/service/${service._id}`}>
                              Learning Disabilities
                            </Link>
                          </li>
                          <li>
                            <Link to={`/service/${service._id}`}>
                              End of Life Care
                            </Link>
                          </li>
                          <li>
                            <Link to={`/service/${service._id}`}>
                              Specialised Care
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </React.Fragment>
                  ))}
                </ul>
              </li>

              <li>
                <Link to="/casestudy">
                  <a href="">Case Studies</a>
                </Link>
              </li>

              <li className="dropdown">
                <a href="">
                  <Link>
                    <span>Join our team</span>
                  </Link>

                  <i className="bi bi-chevron-down toggle-dropdown"></i>
                </a>
                <ul>
                  <Link to="/career">
                    <li>Careers</li>
                  </Link>
                  {/* <Link to="/whywork">
                    <li>
                      <a href="">Why Jr care Ltd</a>
                    </li>
                  </Link> */}
                </ul>
              </li>
            </ul>

            <div className="mobile-view">
              <Button className="off-button" onClick={handleShow}>
                <FaBars className="bar" />
              </Button>

              <Offcanvas
                show={show}
                onHide={handleClose}
                className="custom-offcanvas"
              >
                <Offcanvas.Header closeButton></Offcanvas.Header>
                <Offcanvas.Body className="off-body">
                  <nav className="d-flex flex-column gap-3">
                    {/* HOME */}
                    <div className="d-flex align-items-center p-2 rounded transition">
                      <div className="me-3">
                        <i className="bi bi-house fs-2 text-primary "></i>
                      </div>
                      <Link
                        to="/"
                        className="fs-6 text-dark text-decoration-none"
                        onClick={handleClose}
                      >
                        HOME
                      </Link>
                    </div>

                    {/* ABOUT */}

                    <div>
                      <div
                        className="d-flex align-items-center justify-content-between p-2 rounded cursor-pointer"
                        onClick={() => toggleDropdown("about")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <i className="bi bi-info-circle fs-2 text-primary"></i>
                          </div>
                          <span className="fs-6 text-dark">ABOUT</span>
                        </div>
                        <div>
                          <i
                            className={`bi bi-chevron-right fs-4 ${
                              dropdownOpen.about ? "rotate-90" : ""
                            }`}
                          ></i>
                        </div>
                      </div>
                      {dropdownOpen.about && (
                        <div className="ms-4 mt-2 mb-2">
                          <ul className="list-unstyled">
                            <li>
                              <Link
                                to="/Aboutz"
                                className="text-dark text-decoration-none"
                                onClick={handleClose}
                              >
                                <p className="pot">About Us</p>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/Socialvalue"
                                className="text-dark text-decoration-none"
                                onClick={handleClose}
                              >
                                <p className="pot">Social Values</p>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* SERVICES */}

                    <div>
                      <div
                        className="d-flex align-items-center justify-content-between p-2 rounded cursor-pointer"
                        onClick={() => toggleDropdown("services")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <i className="bi bi-card-list fs-2 text-primary"></i>
                          </div>
                          <span className="fs-6 text-dark">SERVICES</span>
                        </div>
                        <div>
                          <i
                            className={`bi bi-chevron-right fs-4 ${
                              dropdownOpen.services ? "rotate-90" : ""
                            }`}
                          ></i>
                        </div>
                      </div>
                      {dropdownOpen.services && (
                        <div className="ms-4 mt-2 mb-2">
                          <ul className="list-unstyled">
                            {feadata.map((service) => (
                              <li key={service._id}>
                                <Link
                                  to={`/service/${service._id}`}
                                  className="text-dark text-decoration-none"
                                  onClick={handleClose}
                                >
                                  <p className="pot">{service.title}</p>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* CAREERS */}
                    <div className="d-flex align-items-center p-2 rounded transition">
                      <div className="me-3">
                        <i className="bi bi-briefcase fs-2 text-primary"></i>
                      </div>
                      <Link
                        to="/career"
                        className="fs-6 text-dark text-decoration-none"
                        onClick={handleClose}
                      >
                        CAREERS
                      </Link>
                    </div>

                    {/* CASE STUDIES */}
                    <div className="d-flex align-items-center p-2 rounded transition">
                      <div className="me-3">
                        <i className="bi bi-bar-chart fs-2 text-primary"></i>
                      </div>
                      <Link
                        to="/casestudy"
                        className="fs-6 text-dark text-decoration-none"
                        onClick={handleClose}
                      >
                        CASE STUDIES
                      </Link>
                    </div>

                    {/* CONTACT US */}
                    <div className="d-flex align-items-center p-2 rounded transition">
                      <div className="me-3">
                        <i className="bi bi-person-lines-fill fs-2 text-primary"></i>
                      </div>
                      <Link
                        to="/contact"
                        className="fs-6 text-dark text-decoration-none"
                        onClick={handleClose}
                      >
                        CONTACT US
                      </Link>
                    </div>
                  </nav>
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </nav>

          <Link to="/contact">
            {/* <li> */}

            <a href="#" className="cta-btn">
              {" "}
              CONTACT US
            </a>
            {/* </li> */}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
